<aside>
  <mat-accordion class="locations-freight-accordion">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <figure class="container-icon-start">
            <img src="/assets/svg/icons/icon-star-purple.svg" alt="">
          </figure>
          Ubicaciones recientes
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <ul class="container-last-locations">
          <li class="location">
            <figure><img src="/assets/svg/icons/icon-star-purple.svg" alt=""></figure>
            Calle 72, Bogotá
          </li>
          <li class="location">
            <figure><img src="/assets/svg/icons/icon-star-purple.svg" alt=""></figure>
            Avenida calle 100, Bogotá
          </li>
          <li class="location">
            <figure><img src="/assets/svg/icons/icon-star-purple.svg" alt=""></figure>
            Calle 56, Cundinamarca
          </li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header (click)="fixedAddressMap()">
        <mat-panel-title>
          <figure class="container-icon-start">
            <img src="/assets/svg/icons/icon-star-purple.svg" alt="">
          </figure>
          Fijar dirección en el mapa
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
  </mat-accordion>
</aside>
